import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetconsumptionReducer(state = initialState.budgetconsumption, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETCONSUMPTION_SUCCESS:
      return action.budgetconsumption;
    default:
      return state;
  }
}
